<template>
    <v-row class="mb-5"
           v-if="store"
           justify="end">
        <v-col cols="12"
               sm="6"
               lg="8"
               md="6"
               xs="12"
        >
            <v-alert
                v-if="store && store.stripe_account_id === null"
                border="bottom"
                align="left"
                colored-border
                icon="mdi-cash"
                type="error"
                elevation="2"
            >
                <h3>Oops, un souci avec Stripe</h3>
                <div class="subtitle-1">Tu ne disposes pas d'un compte Stripe Connect</div>
                <span class="body-2">Par conséquent, il n'est pas possible de procéder au transfert automatique de tes pièces</span><br/>
                <span class="body-2">Contacte <a href="mailto:lisa@imparfaiteparis.com">lisa@imparfaiteparis.com</a> pour résoudre le problème (avec ton RIB et ta CNI si ce n’est pas déjà fait).</span>
            </v-alert>
            <v-alert
                v-else-if="store && store.stripe_account_certified === false"
                border="bottom"
                align="left"
                colored-border
                icon="mdi-cash"
                type="error"
                elevation="2"
            >
                <h3>Oops, un souci avec Stripe</h3>
                <div class="subtitle-1">Ton compte Stripe Connect n'est pas vérifié</div>
                <span class="body-2">Par conséquent, il n'est pas possible de procéder au virement de tes pièces vers ton compte bancaire.</span><br/>
                <span class="body-2">Contacte <a href="mailto:lisa@imparfaiteparis.com">lisa@imparfaiteparis.com</a> pour résoudre le problème (avec ton RIB et ta CNI si ce n’est pas déjà fait).</span>
            </v-alert>
        </v-col>
        <v-col
                cols="12"
                sm="6"
                lg="4"
                md="6"
                xs="12"
                v-for="stat of statsItems"
                :key="stat.title"
        >
            <base-material-stats-card
                    :color="stat.color"
                    :icon="stat.icon"
                    :title="stat.title"
                    :value="stat.value"
                    :sub-icon="stat.sub_icon"
                    :sub-text="stat.sub_text"
            />
        </v-col>
    </v-row>
</template>

<script>
    import {mapState} from "vuex";

    export default {
        name: 'OrdersStats.vue',
        data() {
            return {
                store: {},
            }
        },
        methods: {
            loadStore() {
                if (this.userInformation.store_id) {
                    this.loading = true;
                    this.$axios.get('stores/' + this.userInformation.store_id)
                        .then(response => {
                            this.loading = false;
                            this.store = response.data;
                        });
                }

            },
        },
        mounted() {
            this.loadStore();
        },
        computed: {
            ...mapState(['userInformation']),
            queryStatus: function () {
                return this.$route.query['status[]'] || this.$route.query['status'] || [];
            },
            statsItems: function () {

                const stats = [];

                // Coming orders.
                if (this.queryStatus && this.queryStatus.includes('PENDING_DELIVERY') && this.queryStatus.includes('PENDING_CUSTOMER_ACCEPTANCE') && this.queryStatus.includes('AVAILABLE_FOR_TRANSFER')) {
                    stats.push({
                        color: 'orange',
                        icon: 'mdi-poll',
                        title: this.$i18n.t('dashboard.product_pending_amount'),
                        value: this.$i18n.n(this.store.stats_products_pending_price_amount, 'currency'),
                        sub_icon: 'mdi-calendar',
                        sub_text: this.store.stats_products_pending_count + ' ' + this.$i18n.t('dashboard.products_pending')
                    });
                }

                // Available orders.
                if (this.queryStatus && this.queryStatus.includes('TRANSFERRED')) {
                    stats.push({
                        color: 'success',
                        icon: 'mdi-poll',
                        title: this.$i18n.t('dashboard.balance_stripe'),
                        value: this.$i18n.n(this.store.stripe_balance_amount, 'currency'),
                        sub_text: this.$i18n.t('orders_stats.stripe_description')
                    });
                }

                // Paid orders.
                if (this.queryStatus && this.queryStatus.includes('TRANSFERRED') && this.store.stripe_snapshot_balance_amount > 0) {
                    stats.push({
                        color: 'success',
                        icon: 'mdi-poll',
                        title: this.$i18n.t('dashboard.balance_legacy_stripe'),
                        value: this.$i18n.n(this.store.stripe_snapshot_balance_amount, 'currency'),
                        sub_icon: 'mdi-calendar',
                        sub_text: this.$i18n.t('dashboard.before_date')
                    });
                }


                if (this.queryStatus && this.queryStatus.includes('PAID')) {
                    stats.push({
                        color: 'success',
                        icon: 'mdi-poll',
                        title: this.$i18n.t('dashboard.total_payouts_amount'),
                        value: this.$i18n.n(this.store.stripe_total_payout_amount, 'currency'),
                    });
                }

                return stats;
            }
        },
        watch: {},
    }
</script>
